/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const MasterDataPage = lazyLoad(
  () => import('./index'),
  module => module.MasterDataPage,
);
